export default "__VITE_ASSET__c05b58e8__"